<!-- <div class="px-6 py-4"> -->
<div class="w-full flex justify-start items-center p-4 lg:p-4">
    <i class="ico-Close cursor-pointer text-xl ml-3" (click)="dialogRef.close()"></i>
    <h3 class="text-lg">امکانات {{ data.hotelFullName }}</h3>
</div>
<ng-container *ngIf="data.type != 2 && data.alternativeFacilities">
    <div class="h-[88%] overflow-y-auto ps-3 me-3 facilities-modal-wrapper">
        <h4 class="my-4">{{otherFacilities.Name}}</h4>
        <div class="grid grid-cols-2 gap-2">
            <div class="" *ngFor="let item of data.alternativeFacilities">
                <div class="flex items-center gap-4">
                    <ng-container
                        *ngIf="!item.IconClassName.includes('ico-Parking') && !item.IconClassName.includes('ico-Wifi') ">

                        <i class="text-2xl text-muted {{ replaceIcon(item.IconClassName) }}"></i>
                        <span class="text-muted text-sm">{{ item.Name }}</span>
                        <span *ngIf="item.AskFree && !item.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            شامل هزینه
                        </span>
                        <span *ngIf="!item.AskFree && item.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            رایگان
                        </span>

                    </ng-container>

                    <ng-container *ngIf="item.InternetClassName || item.ParkingClassName">
                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <i class="text-2xl text-muted {{ replaceIcon(item.IconClassName) }}"></i>
                                <span class="text-muted text-sm mx-2">{{ item.Name }}</span>
                                <span *ngIf="item.InternetClassName?.includes('with-money','limited')"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    شامل هزینه
                                </span>
                                <span *ngIf="item.ParkingClassName?.includes('with-money','limited')"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    شامل هزینه
                                </span>

                                <span *ngIf="item.InternetClassName == 'has-not'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    ندارد
                                </span>
                                <span *ngIf="item.ParkingClassName == 'has-not'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    ندارد
                                </span>

                                <span *ngIf="item.ParkingClassName == 'free'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان

                                </span>
                                <span *ngIf="item.InternetClassName == 'free'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان

                                </span>
                            </div>

                            <p *ngIf="item.Description" class="text-sm text-black-300 mt-3">{{item.Description}}</p>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
        <ng-container *ngIf="data.travelHealth">
            <h4 class="my-4">{{data.travelHealth.Title}}</h4>

            <div class="grid grid-cols-2 gap-2">
                <div *ngFor="let item of data.travelHealth.HotelFacilities" class="flex items-top gap-2 text-black-300">
                    <i class="text-xl {{replaceIcon(item.IconClassName)}}"></i>
                    <div class="flex flex-col">
                        <h5 class="text-black-300 text-sm">{{item.Name}}</h5>
                        <p class="text-sm">{{item.Description}}</p>

                    </div>
                </div>
            </div>
        </ng-container>

        <div *ngIf="data?.dataSource && data?.dataSource?.length">

            <ng-container *ngFor="let item of data.dataSource">
                <ng-container *ngIf="item.HotelFacilities && item.HotelFacilities.length">

                    <h4 class="my-4">{{item.Name}}</h4>

                    <div class="grid grid-cols-2 gap-2">
                        <ng-container *ngFor="let facility of item.HotelFacilities">
                            <div class="flex items-center gap-2 text-black-300"
                                *ngIf="!facility.IconClassName.includes('ico-Parking')">

                                <i *ngIf="item.Id === 0" [ngClass]="replaceIcon(facility.IconClassName)"
                                    class="text-xl"></i>
                                <h5 class="text-sm">{{facility.Name}}</h5>
                                <span *ngIf="facility.AskFree && !facility.IsFree"
                                class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                شامل هزینه
                            </span>
                                <span *ngIf="!facility.AskFree && facility.IsFree"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان
                                </span>

                            </div>

                        </ng-container>
                    </div>

                </ng-container>
            </ng-container>


        </div>
    </div>

</ng-container>
<ng-container *ngIf="data.type == 2 && data.alternativeFacilities">
    <div class="h-[88%] overflow-y-auto ps-3 me-3 facilities-modal-wrapper">
        <div class="grid grid-cols-2 gap-2" *ngIf="data.alternativeFacilities">
            <div *ngFor="let item of data.alternativeFacilities">
                <div class="flex items-center gap-4">
                    <ng-container
                        *ngIf="!item.IconClassName.includes('ico-Parking') && !item.IconClassName.includes('ico-Wifi') ">

                        <i class="text-2xl text-muted {{ replaceIcon(item.IconClassName) }}"></i>
                        <span class="text-muted text-sm">{{ item.Name }}</span>
                        <span *ngIf="item.AskFree && !item.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            شامل هزینه
                        </span>
                        <span *ngIf="!item.AskFree && item.IsFree"
                            class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                            رایگان
                        </span>

                    </ng-container>

                    <ng-container *ngIf="item.InternetClassName || item.ParkingClassName">
                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <i class="text-2xl text-muted {{ replaceIcon(item.IconClassName) }}"></i>
                                <span class="text-muted text-sm mx-2">{{ item.Name }}</span>
                                <span *ngIf="item.InternetClassName?.includes('with-money','limited')"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    شامل هزینه
                                </span>
                                <span *ngIf="item.ParkingClassName?.includes('with-money','limited')"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    شامل هزینه
                                </span>

                                <span *ngIf="item.InternetClassName == 'has-not'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    ندارد
                                </span>
                                <span *ngIf="item.ParkingClassName == 'has-not'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    ندارد
                                </span>

                                <span *ngIf="item.ParkingClassName == 'free'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان

                                </span>
                                <span *ngIf="item.InternetClassName == 'free'"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان

                                </span>
                            </div>

                            <p *ngIf="item.Description" class="text-sm text-black-300 mt-3">{{item.Description}}</p>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
        <div *ngIf="data?.dataSource && data?.dataSource?.length">

            <ng-container *ngFor="let item of data.dataSource">
                <ng-container *ngIf="item.HotelFacilities.length">
                    <h4 class="my-4">{{item.Name}}</h4>

                    <div class="grid grid-cols-2 gap-2">
                        <ng-container *ngFor="let facility of item.HotelFacilities">
                            <div class="flex items-center gap-2 text-black-300">
                                <img [src]="facility.PictureUrl">
                                <h5 class="text-sm">{{facility.Name}}</h5>
                                    <span *ngIf="facility.AskFree && !facility.IsFree"
                                        class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                        شامل هزینه     </span>
                                <span *ngIf="!facility.AskFree && facility.IsFree"
                                    class="bg-gray-200 text-metal-500 text-sm font-medium me-2 px-2.5 py-0.5 rounded whitespace-nowrap">
                                    رایگان
                                </span>

                            </div>

                        </ng-container>
                    </div>

                </ng-container>

            </ng-container>

        </div>
    </div>
</ng-container>